import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 446 242",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .059082,
			width: 55,
			height: 241,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 65.5,
			y: 60.0591,
			width: 55,
			height: 181,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 130.5,
			y: 180.059,
			width: 55,
			height: 61,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 195.5,
			y: 124.059,
			width: 55,
			height: 117,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 260.5,
			y: 180.059,
			width: 55,
			height: 61,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 325.5,
			y: 92.0591,
			width: 55,
			height: 149,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 390.5,
			y: 60.0591,
			width: 55,
			height: 181,
			rx: 2,
			fill: "currentColor"
		})
	]
});
export default SvgBarChart;
